export default Object.freeze({
  OPEN: 'open',
  CLOSED: 'closed',
})
